
import React, { useEffect, useCallback, useState} from 'react';
import ParameterKnob from "components/knobs/ParameterKnob.js";
import {connect} from 'react-redux';
import EffectParameterSlider from "components/effects/EffectParameterSlider.js";
import {effectOptions} from 'components/effects/constants.js';
import './effects.scss';


const skip_fx = ["Wave Folder", "Soft Clipper", "Bit Crusher", "Compressor", "Saturator",  "Delay", "Oscilloscope", "Guitar Amp", "Freak Shifter", "Frequency Shifter",
                 "Effect Rack", "EQ 8", "Convolver Reverb", "Filter", "Panner", "Transient Shaper"];
let EFFECTS = effectOptions.filter(x =>
    !skip_fx.includes(x.label));
; /*["Chorus", value: "Chorus"},
    {label: "Distortion", value: "Distortion"},
    {label: "Phaser", value: "Ultra Phaser"},
    {label: "Tape Delay", value: "Tape Delay"},
];*/

const SynthzEffects = ({track}) => { 
    let [effects, setEffects] = useState([]);
    let [showEffects, setShowEffects] = useState(false);

    useEffect(() => {
        // on track load create two effects and bypass them
        let {scripting} = track.sequencerEngine;
        scripting.runScript('+Chorus');
        scripting.runScript('+Convolver Reverb');
        setEffects(track.effects);
    }, [setEffects, track]);

    const addEffect = useCallback((fx) => {
        if (fx === "Phaser") {
            fx = "Ultra Phaser";
        }
        let wet = track.effects[0].wetParameter.get();
        track.effectsChain.deleteEffect(effects[0]);
        let {scripting} = track.sequencerEngine;
        scripting.runScript('+' + fx);
        setShowEffects(false);
        track.effectsChain.moveEffectTo(2, 0);
        if (fx === "Distortion") {
            track.effects[0].distortionParameter.set(0.8);
        }
        track.effects[0].wetParameter.set(wet);
        setEffects([... track.effects]);

    }, [effects, setEffects, setShowEffects]);

    useEffect(() => {
        window.addEventListener("click", clearChooser);
        return () => window.removeEventListener("click", clearChooser);
    }, [setShowEffects]);

    const clearChooser = useCallback(() => {
        setShowEffects(false);
    }, [setShowEffects]);

    if (effects.length === 0) {
        return '';
    }
    let rateParameter  = effects[0].parameters.find(x => x.name.includes("Rate"));
    return (
        <div className="synthz-effects">
          <div className="synthz-effect">
            <div
              onClick={(e) => {
                  e.stopPropagation();
                  setShowEffects(true);
              }}
              className="effect-name">
              {effects[0].name}
              <div className="effects-chooser">
                <div                      className="arrow-down"/>
                {showEffects &&
                 <div
                   onClick={e => e.stopPropagation()}
                   className="effect-dropdown">
                   {EFFECTS.map(
                       ({label, value}) =>
                       <div
                         onClick={() => addEffect(value)}
                         className="effect-option">
                         {label}
                       </div>)}
                 </div>}
              </div>
            </div>
            <ParameterKnob size={125} parameter={effects[0].parameters.find(x => x.name === "Wet")}/>
            {rateParameter && <EffectParameterSlider
                                name="Rate"
                                parameter={rateParameter}
                                min={0}
                                max={1}
                                step={0.01}
                                sequencerEngine={track.sequencerEngine}/>}
          </div>
          <div className="synthz-effect">
            <div className="effect-name">{effects[1].name}</div>
            <ParameterKnob size={125} parameter={effects[1].parameters[0]}/>
          </div>
        </div>);
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SynthzEffects);
